const version = {
  number: '1.0.0',
};

export default version;
